// removed by extract-text-webpack-plugin
module.exports = {"Container":"_3wDW7","ContainerPrimary":"_3D4CJ","ContainerSecondary":"_VQxn3","Box1":"_3Dy71","Box2":"_3fLFv","AirlineDetail":"_3BfcU","Dash":"_19sH_","RefundType":"_1WZQ_","Details":"_31cHv","DashedBorder":"_yIabK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/TupleStacked/TupleStacked.scss
// module id = 502
// module chunks = 0